import { emptyObject } from '@constants/empty';
import create from 'zustand';
import createStoreSelectors from '../utils/createStoreSelector';

const useStore = create((set) => ({
  areGoalOnBoardingPreferencesUpdated: emptyObject,
  setGloPreferencesUpdated: (goalUID, areUpdated) => {
    set((state) => ({
      ...state,
      areGoalOnBoardingPreferencesUpdated: {
        ...state.areGoalOnBoardingPreferencesUpdated,
        [goalUID]: areUpdated
      }
    }));
  }
}));

const useGoalOnboardingStore = createStoreSelectors(useStore);

export default useGoalOnboardingStore;
